<div [class.pr-small-x]="includePaddings" [class.pr-small-t]="includePaddings">
  <button
    [attr.id]="'service-item-' + uuid"
    [attr.aria-controls]="'service-item-content-' + uuid"
    [attr.aria-expanded]="expandOpen"
    class="fill flex no-outline"
    (click)="expandOpen = !expandOpen"
    [disabled]="disabled"
  >
    <div class="btn-content fill flex flex--space-between">
      <span class="flex flex--top ms-xsmall-r fill">
        <fcom-icon [name]="getIconForService()" class="icon-medium ms-xsmall-r nordic-blue-900-text flex--shrink0" />
        <div class="flex-1">
          <span class="medium-type font-heading-5 flex align-left flex--wrap">
            <span class="flex-1" data-testid="product-item-title">{{ buttonTranslationKey | finLocalization }}</span>
            <span class="flex--nogrow" data-testid="product-item-additional-title">{{ additionalTitle }}</span>
          </span>
          <fin-included-product-item-summary
            *ngIf="!expandOpen || service?.upsell"
            class="fill align-left block"
            [passengers]="passengers"
            [bound]="bound"
            [service]="service"
            [isShortHaulFlight]="isShortHaulFlight"
            [showPendingServicesInTitles]="showPendingServicesInTitles"
          />
        </div>
      </span>
      @if (showUnpaidTag && service.unpaidQuantity && !expandOpen) {
        <div class="flex-1">
          <fcom-tag [theme]="TagTheme.WARNING" class="ms-xsmall-r nowrap" data-testid="unpaid-item-tag">
            <fcom-icon [name]="SvgLibraryIcon.SHOPPING_CART" class="icon-small ms-xxsmall-r" />
            <span class="nowrap dn-laptop-down">
              {{
                service.unpaidQuantity === 1
                  ? ('MMB.includedProducts.unpaidAncillaries.tagTitleSingular'
                    | finLocalization: { quantity: service.unpaidQuantity })
                  : ('MMB.includedProducts.unpaidAncillaries.tagTitlePlural'
                    | finLocalization: { quantity: service.unpaidQuantity })
              }}
            </span>
            <span class="dn-laptop-up">{{ service.unpaidQuantity }}</span>
          </fcom-tag>
        </div>
      }

      <fcom-icon
        class="flex-1 flex--nogrow rotate icon-medium nordic-blue-900-text"
        [class.rotate-active]="expandOpen"
        [name]="SvgLibraryIcon.CHEVRON_DOWN"
      />
    </div>
  </button>
</div>

<fcom-expand
  class="block"
  [open]="expandOpen"
  [ariaId]="'service-item-content-' + uuid"
  [ariaLabelledBy]="'service-item-' + uuid"
>
  <div
    class="flex flex--column"
    [ngClass]="{ 'ms-xsmall-t': !includePaddings, 'mr-small-t pr-small-x': includePaddings }"
  >
    <div *ngIf="displaySeatReassignMessage" class="white-bg rounded-large border mr-medium-b">
      <div class="pr-xsmall">
        <div class="ms-small-b">
          <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.INFO" />
          <span class="font-body-1 medium-type">
            {{ 'MMB.purchase.success.seats.reassignNote.title' | finLocalization }}
          </span>
        </div>
        <div class="font-body-1 mr-medium-l">
          {{ 'MMB.purchase.success.seats.reassignNote.message' | finLocalization }}
        </div>
      </div>
    </div>
    <ng-content />
  </div>
</fcom-expand>
